import snakeCase from 'lodash/snakeCase'
import { ChartName } from 'shared/__gql-types'
import { TAutoCompleteOption } from 'shared/types/SelectOptions'

export function objToSnakeCase<T extends Record<string, any>>(data: T): T {
  return Object.entries(data).reduce((a, [key, value]) => ({ ...a, [snakeCase(key)]: value }), {} as T)
}

export const getResultData = (type: keyof ChartName, results: ChartName[]) =>
  results.reduce(
    (acc: TAutoCompleteOption[], chart: ChartName): TAutoCompleteOption[] => {
      if (chart[type]) {
        return [...acc, { value: chart[type] ?? '', label: chart[type] ?? '' }]
      }
      return acc
    },
    []
  )
